import { ReactElement } from 'react'
import Add from '@mui/icons-material/Add'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'

interface Props extends LoadingButtonProps {
  children?: string | ReactElement
}

const AddButton = ({ children, ...props }: Props): ReactElement => (
  <LoadingButton
    variant="contained"
    color="primary"
    startIcon={children ? <Add /> : undefined}
    {...props}
  >
    {children || '+'}
  </LoadingButton>
)

export default AddButton
